import React from "react";
import {
  ChipsContainer,
  ViewChip,
  TreatmentStepEmptyValue,
} from "./TreatmentStepChips.styled";

interface TreatmentStepChipsProps {
  values: string[];
  emptyLabel?: string;
}

const TreatmentStepChips: React.FC<TreatmentStepChipsProps> = ({
  values,
  emptyLabel = "—",
}) => {
  if (values.length === 0) {
    return <TreatmentStepEmptyValue>{emptyLabel}</TreatmentStepEmptyValue>;
  }

  return (
    <ChipsContainer>
      {values.map((value) => (
        <ViewChip key={value}>{value}</ViewChip>
      ))}
    </ChipsContainer>
  );
};

export default TreatmentStepChips;
